(() => {
  const depositProperty = '_Aurora refundable deposit for';
  const legacyFeeProperty = '_Aurora initial fee for';
  const legacyInitialFeeVariantIds = new Set([
    '43152768499783',
    '43147733401671',
    '43148424773703',
    '43158470524999'
  ]);

  const numberValue = (value) => {
    const parsed = Number(String(value || '').split('/').pop());
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const formProperties = (form) => {
    const properties = {};
    new FormData(form).forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = String(value);
    });
    return properties;
  };

  const hasPrivateProperty = (item, key, handle) =>
    item && item.properties && String(item.properties[key] || '') === handle;

  const cleanupLegacyInitialFees = async () => {
    try {
      const cartResponse = await fetch(window.routes.cart_url + '.js', {
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      const updates = {};

      cart.items.forEach((item) => {
        const variantId = String(item.variant_id || item.id || '');
        const hasLegacyFeeProperty =
          item.properties && Object.prototype.hasOwnProperty.call(item.properties, legacyFeeProperty);

        if (legacyInitialFeeVariantIds.has(variantId) || hasLegacyFeeProperty) {
          updates[item.key] = 0;
        }
      });

      if (!Object.keys(updates).length) return;

      const response = await fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });

      if (response.ok) window.location.reload();
    } catch (error) {
      console.error('Aurora legacy initial fee cleanup failed', error);
    }
  };

  const runCleanup = () => window.setTimeout(cleanupLegacyInitialFees, 0);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCleanup, { once: true });
  } else {
    runCleanup();
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const productForm = form.closest('product-form[data-aurora-product-handle]');
    if (!productForm) return;

    const depositVariant = numberValue(productForm.dataset.auroraDepositVariant);
    if (!depositVariant) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const handle = productForm.dataset.auroraProductHandle || '';
    const variantInput = form.querySelector('input[name="id"]');
    const variantId = numberValue(variantInput && variantInput.value);
    if (!variantId) return;

    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, numberValue(quantityInput && quantityInput.value) || 1);
    const submitter = event.submitter || form.querySelector('[type="submit"]');

    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }

    try {
      const cartResponse = await fetch(window.routes.cart_url + '.js', {
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) throw new Error('Unable to read cart');
      const cart = await cartResponse.json();

      const items = [{ id: variantId, quantity, properties: formProperties(form) }];

      if (!cart.items.some((item) => hasPrivateProperty(item, depositProperty, handle))) {
        items.push({
          id: depositVariant,
          quantity: 1,
          properties: { [depositProperty]: handle }
        });
      }

      const response = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || 'Unable to add items');
      }

      window.location.href = window.routes.cart_url;
    } catch (error) {
      if (submitter) {
        submitter.disabled = false;
        submitter.removeAttribute('aria-busy');
      }

      const lang = document.documentElement.lang || '';
      const message = lang.startsWith('ja')
        ? '商品をカートに追加できませんでした。在庫を確認して、もう一度お試しください。'
        : lang.startsWith('en')
          ? 'The items could not be added to the cart. Please check availability and try again.'
          : 'Não foi possível adicionar os itens ao carrinho. Confira a disponibilidade e tente novamente.';
      window.alert(message);
    }
  }, true);
})();
